import theme from '@/theme';
import styled from '@emotion/styled';

export const GeneralContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const RootContainer = styled(GeneralContainer)`
    gap: 40px;
`;

export const TitleContainer = styled(GeneralContainer)`
    gap: 4px;
`;

export const ContentContainer = styled(RootContainer)`
    gap: 24px;
`;

export const Divider = styled.div`
    width: 100%;
    height: 1px;
    border-bottom: 1px solid ${theme.colors.secondary[100]};
`;
